function delayedRedirectToUrl(url) {
  setTimeout(() => {
    window.location.href = url
  }, 5000)
}

export default delayedRedirectToUrl
